import type { PageInitInput, PageInitOutput, PageStreamInput } from '@/domains/seek/types';
import type { PsHttpSSE } from '@patsnap-utils/sse';
import type { RequestConfig } from '@patsnap/common-ps-http';
import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core';

export const PageApi = Symbol('PageApi');

export interface PageApi {
    pageInit(initData: PageInitInput): Promise<PageInitOutput>;
    getPageStream<T>(streamInput: PageStreamInput): PsHttpSSE<T>;
    stopPageStreamEvent(question_id: string):Promise<unknown>;
    request<T extends PatSnapCommonResponseData>(config: RequestConfig): Promise<T>;
    seekRewrite(question_id: string, deep_input: string): Promise<string>;
}
